import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.utils.toArray( '[data-component="media-gallery"]' ).forEach( function( $componentEl ) {
        const $parallaxWrappers = gsap.utils.toArray( $componentEl.querySelectorAll( '[data-speed]' ) );
        $parallaxWrappers.forEach( ( $item ) => {
          gsap.to( $item, {
            yPercent: -150,
            ease: 'none',
            scrollTrigger: {
              trigger: $item,
              start: 'top 80%',
              end: 'bottom',
              scrub: true,
              invalidateOnRefresh: true,
            },
          } );
        } );

        gsap.utils.toArray( $componentEl.querySelectorAll( '.js-media-gallery-image-wrapper' ) ).forEach( function( $imageWrapper ) {
          const $image = $imageWrapper.querySelector( 'img' );
          gsap.to( $image, {
            y: () => $image.offsetHeight - $imageWrapper.offsetHeight,
            ease: 'none',
            scrollTrigger: {
              trigger: $componentEl,
              scrub: true,
              pin: false,
              invalidateOnRefresh: true,
            },
          } );
        } );

        const $stickyEl = $componentEl.querySelector( '.js-media-gallery-sticky' );
        if ( $stickyEl ) {
          gsap.to( $stickyEl, {
            ease: 'none',
            scrollTrigger: {
              trigger: $stickyEl,
              start: 'bottom bottom',
              end: () => `+=${$componentEl.offsetHeight}`,
              scrub: true,
              pinSpacing: false,
              pin: true,
              invalidateOnRefresh: true,
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'media-gallery', COMPONENT );
} )( app );
